import type { Order } from '@brighterly/lib-core-types/orders/interfaces'
import type { CheckoutStore } from './interfaces'

import { entryData } from '@shared/lib/scope'

export const getOrder = (state: CheckoutStore): Order | null => entryData(state.orderById, state.activeOrderId)

export const getUpsellOrder = (state: CheckoutStore): Order | null => entryData(state.upsellOrderById, state.activeOrderId)
